var map = {
	"./AcceptInvitationPortal.vue": [
		84938,
		2872,
		9499
	],
	"./AppRoot.vue": [
		51870,
		2639,
		2772,
		5875,
		1492,
		6938,
		1870
	],
	"./AssignmentAccessCodePortal.vue": [
		70492,
		492
	],
	"./AssignmentDetailPortal.vue": [
		62705,
		2705
	],
	"./CustomTokenLoginPortal.vue": [
		27573,
		7573
	],
	"./DriveFileSelectView.vue": [
		78381,
		2872,
		9076
	],
	"./EnrollStudentView.vue": [
		7195,
		2872,
		5875,
		4118
	],
	"./ExtensionLogoutPortal.vue": [
		48395,
		8395
	],
	"./ExtensionUninstallSuccessView.vue": [
		71461,
		1461
	],
	"./IndependentStartView.vue": [
		89815,
		7229,
		307
	],
	"./LocalHostAuthPortal.vue": [
		13859,
		3859
	],
	"./LoginView.vue": [
		85877,
		5877
	],
	"./LogoutPortal.vue": [
		69342,
		2872,
		4223
	],
	"./NewStudentView.vue": [
		26025,
		5875,
		6025
	],
	"./NewTeacherView.vue": [
		42306,
		5875,
		2306
	],
	"./NewUserView.vue": [
		49147,
		5875,
		9147
	],
	"./NoteBoardShareView.vue": [
		44766,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		4766
	],
	"./Oauth2CallbackView.vue": [
		35406,
		2772,
		9423
	],
	"./Oauth2LoginView.vue": [
		16197,
		6197
	],
	"./Oauth2LoginWarningView.vue": [
		34637,
		4637
	],
	"./PageNotFoundView.vue": [
		38173,
		5875,
		8173
	],
	"./RegisterPlatformView.vue": [
		64384,
		2639,
		4636,
		2772,
		5019,
		2560
	],
	"./RespondToAccessRequestView.vue": [
		12368,
		2368
	],
	"./StudentLogoutPortal.vue": [
		9427,
		9427
	],
	"./TeacherTryForFreePortal.vue": [
		81290,
		1290
	],
	"./TeacherTryForFreeRedirectPortal.vue": [
		68357,
		8357
	],
	"./admin/AdminAssignmentsView.vue": [
		28048,
		4636,
		8048
	],
	"./admin/AdminEmailTestsView.vue": [
		18381,
		4636,
		8381
	],
	"./admin/AdminExtensionInstallationsView.vue": [
		76670,
		2639,
		4636,
		2772,
		7980,
		5019,
		3572,
		7098
	],
	"./admin/AdminMiscView.vue": [
		52369,
		4636,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		2369
	],
	"./admin/AdminOrganizationsView.vue": [
		6868,
		2639,
		4636,
		2872,
		2772,
		5019,
		3572,
		2626
	],
	"./admin/AdminRoot.vue": [
		67737,
		7737
	],
	"./admin/AdminUserBackupsNotebookView.vue": [
		70423,
		2639,
		4636,
		2772,
		7980,
		5019,
		3875
	],
	"./admin/AdminUserBackupsView.vue": [
		718,
		718
	],
	"./admin/AdminUsersView.vue": [
		88992,
		2639,
		4636,
		2772,
		5019,
		3572,
		2788
	],
	"./admin/components/AdminForcedExtensionUpdatePanel.vue": [
		65869,
		4636,
		5869
	],
	"./admin/components/AdminNav.vue": [
		13747,
		3747
	],
	"./admin/components/AdminUserBackupNote.vue": [
		52081,
		2639,
		4636,
		2772,
		7980,
		5019,
		8145
	],
	"./admin/components/AssignmentConverter.vue": [
		4488,
		4488
	],
	"./admin/components/AssignmentDataLoader.vue": [
		87432,
		4636,
		7432
	],
	"./admin/components/BackFillNotePermissions.vue": [
		68370,
		8370
	],
	"./admin/components/CopyUser.vue": [
		92925,
		4636,
		2925
	],
	"./admin/components/LoggerSessionFix.vue": [
		8512,
		8512
	],
	"./admin/components/ReloadUserDocumentFromRecord.vue": [
		1303,
		4636,
		1303
	],
	"./admin/components/TestAssignmentDetailInviteEmail.vue": [
		86334,
		4636,
		6334
	],
	"./admin/components/TestAssignmentDetailReportEmail.vue": [
		55567,
		4636,
		5567
	],
	"./admin/components/TestAssignmentReportEmail.vue": [
		72587,
		4636,
		2587
	],
	"./admin/components/TestCloudMessage.vue": [
		54481,
		4636,
		4481
	],
	"./admin/components/TestCloudMessageToStudents.vue": [
		49647,
		4636,
		9647
	],
	"./admin/components/TestCommandsHtml.vue": [
		17339,
		4636,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		7339
	],
	"./admin/components/TestCourseInviteEmail.vue": [
		14288,
		4636,
		4288
	],
	"./admin/components/TestCreateInvitedUser.vue": [
		92891,
		4636,
		2891
	],
	"./admin/components/TestInstructorWelcomeEmail.vue": [
		53542,
		4636,
		3542
	],
	"./admin/components/TestLearnerWelcomeEmail.vue": [
		93790,
		4636,
		3790
	],
	"./admin/components/TestLearnicsUWelcomeEmail.vue": [
		77660,
		4636,
		7660
	],
	"./admin/components/TestLinkGoogleAccount.vue": [
		32309,
		4636,
		2309
	],
	"./admin/components/TestOrganizationInviteEmail.vue": [
		56876,
		4636,
		6876
	],
	"./admin/components/TestScheduledBucketFileCleanup.vue": [
		34164,
		4164
	],
	"./admin/components/TestSlackMessage.vue": [
		20575,
		575
	],
	"./admin/components/TestSlackMessageTeacherTryForFree.vue": [
		85970,
		5970
	],
	"./admin/components/TestUnlinkGoogleAccount.vue": [
		39440,
		4636,
		9440
	],
	"./assignmentForm/AssignmentFormRoot.vue": [
		8497,
		5875,
		8497
	],
	"./assignmentForm/ClassroomAssignmentFormView.vue": [
		22587,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		9462
	],
	"./assignmentForm/LtiAssignmentFormView.vue": [
		63241,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		7124
	],
	"./assignments/AssignmentPortal.vue": [
		13097,
		3097
	],
	"./assignments/AssignmentRoot.vue": [
		74761,
		5875,
		4761
	],
	"./assignments/components/ArchiveAssignmentDialog.vue": [
		83243,
		3243
	],
	"./assignments/components/AssignmentMissing.vue": [
		31510,
		5875,
		1510
	],
	"./assignments/components/AssignmentNoteBoardsList.vue": [
		56441,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		5887,
		7130,
		4671
	],
	"./assignments/components/CategoriesTooltip.vue": [
		85440,
		5440
	],
	"./assignments/components/CategoryNode.vue": [
		25819,
		2639,
		5819
	],
	"./assignments/components/CategoryUrlTable.vue": [
		25412,
		2639,
		650,
		1139
	],
	"./assignments/components/CopyAssignmentDialog.vue": [
		40510,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		2589
	],
	"./assignments/components/ExpectationsLegend.vue": [
		78342,
		5875,
		8342
	],
	"./assignments/components/ExpectationsPieChart.vue": [
		25295,
		5295
	],
	"./assignments/components/ExpectationsTable.vue": [
		75987,
		5875,
		5987
	],
	"./assignments/components/GoogleDriveFileIcon.vue": [
		84961,
		4961
	],
	"./assignments/components/MissingDataAlert.vue": [
		19627,
		9627
	],
	"./assignments/components/PieChart.vue": [
		62338,
		2338
	],
	"./assignments/components/RemoveUsersFromAssignmentConfirmDialog.vue": [
		42321,
		2872,
		8440
	],
	"./assignments/components/SearchDateItem.vue": [
		40221,
		221
	],
	"./assignments/components/SearchQuery.vue": [
		64809,
		4809
	],
	"./assignments/components/SearchStatistics.vue": [
		93084,
		3084,
		8376
	],
	"./assignments/components/StudentProgressReport.vue": [
		56763,
		5875,
		2812,
		6763,
		8943
	],
	"./assignments/components/timeline/D3Timeline.vue": [
		71279,
		2812,
		1279,
		5438
	],
	"./assignments/components/timeline/ScrollableTimeline.vue": [
		54988,
		2639,
		4636,
		2772,
		7980,
		2812,
		5019,
		1279,
		4988,
		5467
	],
	"./assignments/components/timeline/SessionTimeline.vue": [
		9469,
		2639,
		4636,
		2772,
		7980,
		2812,
		5019,
		1279,
		4988,
		9469,
		5045
	],
	"./assignments/components/timeline/SessionTimelineScrollbar.vue": [
		21476,
		1476
	],
	"./assignments/components/timeline/SessionTimelineTooltip.vue": [
		13928,
		7980,
		3928
	],
	"./assignments/student/StudentAssignmentPortal.vue": [
		92764,
		2764
	],
	"./assignments/student/StudentAssignmentRoot.vue": [
		64829,
		4829
	],
	"./assignments/student/start-assignment/MissingLearnicsExtensionView.vue": [
		13640,
		3640
	],
	"./assignments/student/start-assignment/ScheduledAssignmentView.vue": [
		14163,
		7980,
		4163
	],
	"./assignments/student/start-assignment/StartAssignmentRoot.vue": [
		23598,
		3598
	],
	"./assignments/student/start-assignment/StartAssignmentView.vue": [
		26042,
		2639,
		2872,
		7229,
		1433,
		440
	],
	"./assignments/student/start-assignment/components/EllipticalRecordText.vue": [
		46956,
		6956
	],
	"./assignments/student/start-assignment/components/MissingLearnicsExtension.vue": [
		75324,
		5324
	],
	"./assignments/student/start-assignment/components/NoChromeExtensionDialog.vue": [
		97319,
		7319
	],
	"./assignments/student/start-assignment/components/OpenExtensionButton.vue": [
		83551,
		3551
	],
	"./assignments/student/start-assignment/components/OpenFullScreenButton.vue": [
		59601,
		9601
	],
	"./assignments/student/start-assignment/components/OpenPopupButton.vue": [
		55466,
		5466
	],
	"./assignments/student/start-assignment/components/OpenSidePanelButton.vue": [
		24317,
		4317
	],
	"./assignments/student/start-assignment/components/RecordButton.vue": [
		64392,
		7229,
		2122
	],
	"./assignments/student/start-assignment/components/RecordButtonIcon.vue": [
		87229,
		7229,
		3585
	],
	"./assignments/student/start-assignment/components/StudentInstructions.vue": [
		65592,
		2639,
		2872,
		7229,
		1433,
		8795
	],
	"./assignments/student/start-assignment/components/StudentPopupInstructions.vue": [
		32136,
		2136
	],
	"./assignments/student/submissions/StudentAssignmentDataView.vue": [
		6611,
		2639,
		4636,
		2772,
		7980,
		5875,
		2812,
		5019,
		3572,
		1279,
		6993,
		4988,
		3084,
		650,
		6763,
		9469,
		6594
	],
	"./assignments/student/submissions/StudentAssignmentDetailsView.vue": [
		21827,
		7980,
		1827
	],
	"./assignments/student/submissions/StudentAssignmentNoteBoardsView.vue": [
		93837,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		5887,
		7130,
		4671,
		3837
	],
	"./assignments/student/submissions/StudentBibliographyView.vue": [
		58079,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		6505,
		2567,
		960,
		9688,
		746,
		953,
		3611,
		38,
		7934,
		6097
	],
	"./assignments/student/submissions/StudentSubmissionsPortal.vue": [
		36369,
		6369
	],
	"./assignments/student/submissions/StudentSubmissionsRoot.vue": [
		28223,
		2639,
		2772,
		3660
	],
	"./assignments/student/submissions/components/LoggingStatistics.vue": [
		24256,
		7980,
		4256
	],
	"./assignments/student/submissions/components/StudentAssignmentDetailsPanel.vue": [
		30743,
		2639,
		2772,
		8596
	],
	"./assignments/student/submissions/components/SubmissionDatesAndTimes.vue": [
		37247,
		7980,
		7247
	],
	"./assignments/teacher/TeacherAssignmentPortal.vue": [
		29295,
		1676
	],
	"./assignments/teacher/TeacherAssignmentRoot.vue": [
		29352,
		9352
	],
	"./assignments/teacher/submissions/TeacherAssignmentDataView.vue": [
		67828,
		7980,
		6993,
		7508,
		9394
	],
	"./assignments/teacher/submissions/TeacherAssignmentDetailsView.vue": [
		42934,
		7980,
		2934
	],
	"./assignments/teacher/submissions/TeacherAssignmentExpectationsView.vue": [
		81969,
		2872,
		5875,
		2812,
		6763,
		4379
	],
	"./assignments/teacher/submissions/TeacherAssignmentNoteBoardsView.vue": [
		39255,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		5887,
		7130,
		4671,
		9255
	],
	"./assignments/teacher/submissions/TeacherAssignmentRosterView.vue": [
		19267,
		2639,
		4636,
		2872,
		2812,
		5964,
		6627
	],
	"./assignments/teacher/submissions/TeacherCategoriesOfSitesView.vue": [
		26988,
		2639,
		650,
		1757
	],
	"./assignments/teacher/submissions/TeacherNotesTagsAnnotationsView.vue": [
		44590,
		2639,
		2812,
		5658,
		8471,
		6705,
		3853
	],
	"./assignments/teacher/submissions/TeacherOnlineActivityView.vue": [
		1672,
		1672
	],
	"./assignments/teacher/submissions/TeacherSearchesView.vue": [
		30233,
		3084,
		8400
	],
	"./assignments/teacher/submissions/TeacherSiteLogsView.vue": [
		28481,
		2639,
		4636,
		2772,
		7980,
		5019,
		3572,
		6993,
		5097
	],
	"./assignments/teacher/submissions/TeacherStudentWorkFilesView.vue": [
		84083,
		2639,
		2872,
		8661,
		5174,
		913
	],
	"./assignments/teacher/submissions/TeacherSubmissionsPortal.vue": [
		32797,
		2797
	],
	"./assignments/teacher/submissions/TeacherSubmissionsRoot.vue": [
		61114,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		7548,
		6187
	],
	"./assignments/teacher/submissions/components/AssignmentReauthorizationHandler.vue": [
		7893,
		2872,
		3436
	],
	"./assignments/teacher/submissions/components/ContactingStudentLinksDialog.vue": [
		74277,
		4277
	],
	"./assignments/teacher/submissions/components/DriveFileIframeViewer.vue": [
		26948,
		2872,
		8661,
		9105
	],
	"./assignments/teacher/submissions/components/EditAssignment.vue": [
		15408,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		8327
	],
	"./assignments/teacher/submissions/components/GroupSiteDataSection.vue": [
		75101,
		2639,
		2812,
		5658,
		8471,
		6705,
		9404
	],
	"./assignments/teacher/submissions/components/IndividualNote.vue": [
		78471,
		2639,
		8471,
		929
	],
	"./assignments/teacher/submissions/components/IndividualSiteDataSection.vue": [
		21553,
		2639,
		2812,
		5658,
		8471,
		6705,
		2184
	],
	"./assignments/teacher/submissions/components/IndividualSiteDataSectionNotes.vue": [
		855,
		2639,
		2812,
		5658,
		8471,
		811
	],
	"./assignments/teacher/submissions/components/ProgressPieChart.vue": [
		99388,
		9388
	],
	"./assignments/teacher/submissions/components/RouteScrollHook.vue": [
		3405,
		3405
	],
	"./assignments/teacher/submissions/components/SimpleTag.vue": [
		76600,
		6600
	],
	"./assignments/teacher/submissions/components/SitesByTimeChart.vue": [
		84805,
		4805
	],
	"./assignments/teacher/submissions/components/SitesByVisitChart.vue": [
		35876,
		5876
	],
	"./assignments/teacher/submissions/components/StudentByTimeBarChart.vue": [
		7508,
		7508,
		3406
	],
	"./assignments/teacher/submissions/components/StudentCopyListItem.vue": [
		55174,
		2639,
		5174,
		1802
	],
	"./assignments/teacher/submissions/components/StudentItem.vue": [
		37776,
		2639,
		2772,
		7980,
		2812,
		2557
	],
	"./assignments/teacher/submissions/components/SubmissionsList.vue": [
		57548,
		2639,
		2872,
		2772,
		7980,
		5875,
		2812,
		7548,
		6050
	],
	"./assignments/teacher/submissions/components/TeacherAssignmentDetailsPanel.vue": [
		81239,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		9298
	],
	"./assignments/teacher/submissions/components/TeacherAssignmentLinks.vue": [
		41227,
		2639,
		2872,
		2772,
		5875,
		8123
	],
	"./assignments/teacher/submissions/components/TeacherNotesTagsAnnotations.vue": [
		68061,
		2639,
		2812,
		5658,
		8471,
		6705,
		2556
	],
	"./assignments/teacher/submissions/components/UserProfileDisplay.vue": [
		97094,
		7094
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentAiAndIntegrityView.vue": [
		48262,
		2639,
		4636,
		2772,
		7980,
		5019,
		3572,
		6818
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentDataView.vue": [
		17115,
		2639,
		4636,
		2772,
		7980,
		2812,
		5019,
		3572,
		1279,
		6993,
		4988,
		3084,
		650,
		9469,
		7508,
		414
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentNotesTagsAnnotationsView.vue": [
		59188,
		2639,
		2812,
		5658,
		8471,
		2850
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentPortal.vue": [
		46915,
		6915
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentRoot.vue": [
		89583,
		9916,
		2578
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentVisualizationsView.vue": [
		31421,
		1421
	],
	"./assignments/teacher/submissions/individual-student/components/UserSiteDataSection.vue": [
		36360,
		2639,
		2812,
		5658,
		8471,
		9526
	],
	"./components/AccessCodeFormModal.vue": [
		50510,
		4636,
		2872,
		70
	],
	"./components/AccessCodeInput.vue": [
		15147,
		4636,
		5147
	],
	"./components/AddClassroomAssignmentCard.vue": [
		45718,
		5718
	],
	"./components/AnimatedCheck.vue": [
		98048,
		5667
	],
	"./components/AppSpinner.vue": [
		48574,
		8574
	],
	"./components/AppVersion.vue": [
		48487,
		8487
	],
	"./components/AttachmentIcon.vue": [
		12700,
		2700
	],
	"./components/Auth.vue": [
		36586,
		2639,
		2772,
		2239
	],
	"./components/Breadcrumbs.vue": [
		12272,
		2272
	],
	"./components/CopyAccessCodeToClipboard.vue": [
		6183,
		2639,
		6183
	],
	"./components/CopyToClipboardButton.vue": [
		46007,
		2639,
		6007
	],
	"./components/ExtensionLoader.vue": [
		34534
	],
	"./components/FaviconImg.vue": [
		45682,
		5682
	],
	"./components/FreshDeskHelpButton.vue": [
		92556,
		175
	],
	"./components/GoogleLoginButton.vue": [
		22955,
		2955
	],
	"./components/InstructorInvite.vue": [
		31941,
		4636,
		2872,
		5943
	],
	"./components/InstructorSelect.vue": [
		20782,
		2639,
		4636,
		2772,
		5019,
		782,
		6434
	],
	"./components/LearnicsSolidSpinner.vue": [
		49412,
		8661,
		9412
	],
	"./components/LoadingDialog.vue": [
		69195,
		2872,
		182
	],
	"./components/LtiTestStudentMessage.vue": [
		5942,
		5942
	],
	"./components/MasonTree.vue": [
		34804,
		2812,
		5658,
		9411
	],
	"./components/MasonryLayout.vue": [
		62386,
		2812,
		5658,
		892
	],
	"./components/MicrosoftLoginButton.vue": [
		72424,
		2424
	],
	"./components/Navbar.vue": [
		54761,
		2639,
		2772,
		1492,
		6938
	],
	"./components/NavbarFooter.vue": [
		54260,
		4260
	],
	"./components/NavbarNotificationInvite.vue": [
		9149,
		2772,
		2853
	],
	"./components/NavbarNotifications.vue": [
		23703,
		2639,
		2772,
		1492,
		8658
	],
	"./components/PaywallBanner.vue": [
		47517,
		7517
	],
	"./components/PopupWrapper.vue": [
		46271,
		8652
	],
	"./components/ProfileImage.vue": [
		26698,
		6698
	],
	"./components/ResearchNotebookNote.vue": [
		73960,
		2639,
		4636,
		2872,
		2772,
		5875,
		2812,
		432,
		5090,
		3353,
		2567,
		960,
		2414
	],
	"./components/ResearchNotebookYProvider.vue": [
		41729,
		2567,
		1729
	],
	"./components/ResourceCard.vue": [
		85304,
		9916,
		9560
	],
	"./components/ResourceList.vue": [
		17823,
		7823
	],
	"./components/ResourceListItem.vue": [
		1429,
		2639,
		1429
	],
	"./components/ScrollableToolbar.vue": [
		71988,
		2812,
		1988
	],
	"./components/SidePanelSymbol.vue": [
		9007,
		9007
	],
	"./components/SignInWithGoogleButton.vue": [
		56384,
		6384
	],
	"./components/SignInWithGoogleDialog.vue": [
		38593,
		8593
	],
	"./components/SmallScreenTestStudentMessage.vue": [
		77070,
		7070
	],
	"./components/TeacherIcon.vue": [
		63074,
		3074
	],
	"./components/VerticalCaret.vue": [
		15160,
		5160
	],
	"./components/assignmentForm/AssignmentForm.vue": [
		31735,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		6322
	],
	"./components/assignmentForm/AssignmentFormPaywallModal.vue": [
		44387,
		4636,
		2872,
		4933
	],
	"./components/assignmentForm/AssignmentFormTagList.vue": [
		81033,
		2639,
		2772,
		432,
		3353,
		621
	],
	"./components/assignmentForm/AssignmentOutlineForm.vue": [
		55957,
		2639,
		2872,
		5875,
		2812,
		5090,
		8804,
		6195
	],
	"./components/assignmentForm/ClassroomCourseSelectableItem.vue": [
		4619,
		4619
	],
	"./components/assignmentForm/ClassroomCourseSelectableList.vue": [
		1104,
		1104
	],
	"./components/assignmentForm/CourseSelection.vue": [
		80899,
		2639,
		4636,
		2772,
		5019,
		8391
	],
	"./components/assignmentForm/DateTimeInput.vue": [
		19043,
		2639,
		4636,
		9043
	],
	"./components/assignmentForm/DescriptionInput.vue": [
		14297,
		4297
	],
	"./components/assignmentForm/InstructorsForm.vue": [
		41207,
		2639,
		4636,
		2772,
		5019,
		782,
		7024
	],
	"./components/assignmentForm/LimitedNumberInput.vue": [
		8760,
		4636,
		8760
	],
	"./components/assignmentForm/ScheduleDueDates.vue": [
		66271,
		2639,
		4636,
		6271
	],
	"./components/assignmentForm/SectionSelection.vue": [
		8052,
		2639,
		4636,
		2772,
		5019,
		6716
	],
	"./components/assignmentForm/SubmitAssignmentButton.vue": [
		22269,
		2639,
		2269
	],
	"./components/assignmentForm/WrongEmailErrorModal.vue": [
		14639,
		2872,
		7914
	],
	"./components/assignmentForm/advancedOptions/AdvancedOptionsForm.vue": [
		27590,
		2639,
		5875,
		7590
	],
	"./components/assignmentForm/attachments/AttachmentList.vue": [
		94238,
		2639,
		2772,
		2812,
		432,
		9459
	],
	"./components/assignmentForm/attachments/AttachmentListItemTitle.vue": [
		2890,
		2772,
		8043
	],
	"./components/assignmentForm/attachments/AttachmentsForm.vue": [
		91723,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		432,
		2342,
		6505,
		4302,
		1723,
		9061
	],
	"./components/assignmentForm/attachments/LinkAttachmentForm.vue": [
		84302,
		4636,
		7980,
		5875,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		2342,
		6505,
		4302,
		7113
	],
	"./components/assignmentForm/bibliography/BibliographyForm.vue": [
		39435,
		2639,
		4636,
		5875,
		9435
	],
	"./components/assignmentForm/expectations/AttachmentsExpectation.vue": [
		11764,
		2772,
		5697
	],
	"./components/assignmentForm/expectations/EditingGoogleDocsExpectation.vue": [
		85,
		2772,
		602
	],
	"./components/assignmentForm/expectations/ExpectationList.vue": [
		18691,
		4636,
		2772,
		2812,
		3191,
		8389,
		6879,
		6376
	],
	"./components/assignmentForm/expectations/ExpectationListItem.vue": [
		96879,
		4636,
		2772,
		2812,
		3191,
		8389,
		6879,
		958
	],
	"./components/assignmentForm/expectations/ExpectationsForm.vue": [
		44336,
		2639,
		4636,
		2872,
		2772,
		5875,
		2812,
		2342,
		3191,
		8389,
		6879,
		3476,
		1590,
		638,
		9165
	],
	"./components/assignmentForm/expectations/ExternalUrlsExpectation.vue": [
		75996,
		4636,
		8389,
		5996
	],
	"./components/assignmentForm/expectations/PieChartInput.vue": [
		13191,
		2812,
		3191,
		9807
	],
	"./components/assignmentForm/expectations/TimeRangeSlider.vue": [
		71590,
		4636,
		2872,
		5875,
		2342,
		3476,
		1590,
		2054
	],
	"./components/assignmentForm/expectations/TotalTimeForm.vue": [
		43476,
		4636,
		5875,
		2342,
		3476,
		6674
	],
	"./components/bibliography/AuthorsField.vue": [
		85063,
		2639,
		4636,
		2872,
		7980,
		5875,
		2812,
		2209,
		813,
		746,
		4291
	],
	"./components/bibliography/BibliographyAnnotationManager.vue": [
		33611,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		3611,
		3693
	],
	"./components/bibliography/BibliographyEditor.vue": [
		97934,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		6505,
		2567,
		960,
		9688,
		746,
		953,
		3611,
		38,
		7934,
		3523
	],
	"./components/bibliography/CitationEditor.vue": [
		48172,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		746,
		953,
		3611,
		38,
		6865
	],
	"./components/bibliography/CitationField.vue": [
		40038,
		2639,
		7980,
		2812,
		2209,
		813,
		38,
		6347
	],
	"./components/bibliography/EditableCitationField.vue": [
		56765,
		2812,
		2209,
		6765
	],
	"./components/bibliography/ElementsEditor.vue": [
		80953,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		5090,
		746,
		953,
		1113
	],
	"./components/noteboard/AddNoteBoardButton.vue": [
		4940,
		4940
	],
	"./components/noteboard/AppSpinner2.vue": [
		21632,
		8661,
		1632
	],
	"./components/noteboard/CollaborativeNoteBoardNote.vue": [
		89395,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		9395,
		853
	],
	"./components/noteboard/CreateNoteBoardDialog.vue": [
		41573,
		4636,
		2872,
		4727
	],
	"./components/noteboard/CreateNoteBoardForm.vue": [
		86899,
		4636,
		6899
	],
	"./components/noteboard/DeleteNoteBoardDialog.vue": [
		67967,
		2872,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		3978
	],
	"./components/noteboard/EditableNoteBoardTitle.vue": [
		72375,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		2375
	],
	"./components/noteboard/LeaveNoteBoardDialog.vue": [
		72875,
		2872,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		5686
	],
	"./components/noteboard/LinkNotebookButton.vue": [
		31821,
		2872,
		2772,
		7980,
		5875,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		6507
	],
	"./components/noteboard/LoggerSessionSelectionDialog.vue": [
		25742,
		2872,
		2772,
		5875,
		5742,
		2650
	],
	"./components/noteboard/NewNoteButton.vue": [
		81816,
		1816
	],
	"./components/noteboard/NoNoteBoardNotesFoundPanel.vue": [
		98211,
		8211
	],
	"./components/noteboard/NoteBoardAccessRequestDialog.vue": [
		59935,
		9935
	],
	"./components/noteboard/NoteBoardAssignmentInviteDialog.vue": [
		25481,
		2872,
		2772,
		8661,
		1300,
		6244
	],
	"./components/noteboard/NoteBoardBucketFileLoader.vue": [
		48020,
		8020
	],
	"./components/noteboard/NoteBoardCanvas.vue": [
		8865,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		5658,
		9395,
		8865,
		5349
	],
	"./components/noteboard/NoteBoardCreateAccessRequestDialog.vue": [
		71951,
		2872,
		2922
	],
	"./components/noteboard/NoteBoardDragHandle.vue": [
		67156,
		7156
	],
	"./components/noteboard/NoteBoardDropSpotOverlay.vue": [
		6926,
		6926
	],
	"./components/noteboard/NoteBoardHeaderTrashDropSpot.vue": [
		85774,
		5774
	],
	"./components/noteboard/NoteBoardInvitationResponseDialog.vue": [
		10479,
		2872,
		3178
	],
	"./components/noteboard/NoteBoardInvitePanel.vue": [
		64750,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		8916
	],
	"./components/noteboard/NoteBoardInviteUsersButton.vue": [
		61921,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		4934
	],
	"./components/noteboard/NoteBoardLayout.vue": [
		53005,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		8661,
		6505,
		6656,
		2567,
		8804,
		960,
		5658,
		1300,
		4750,
		9395,
		9688,
		4213,
		4168,
		7715
	],
	"./components/noteboard/NoteBoardListItem.vue": [
		45887,
		2639,
		2772,
		2209,
		5887,
		4577
	],
	"./components/noteboard/NoteBoardListView.vue": [
		45443,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		9395,
		1599
	],
	"./components/noteboard/NoteBoardMainPanel.vue": [
		44728,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		6505,
		6656,
		2567,
		8804,
		960,
		5658,
		9395,
		9688,
		4213,
		3857,
		8865,
		9625
	],
	"./components/noteboard/NoteBoardNote.vue": [
		20553,
		2639,
		4636,
		2872,
		2772,
		5875,
		2812,
		432,
		5090,
		3353,
		2567,
		960,
		4448
	],
	"./components/noteboard/NoteBoardNoteLoader.vue": [
		97587,
		7587
	],
	"./components/noteboard/NoteBoardOneClickInviteDialog.vue": [
		51717,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		4032
	],
	"./components/noteboard/NoteBoardOutline.vue": [
		13857,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		8804,
		960,
		9395,
		3857,
		6666
	],
	"./components/noteboard/NoteBoardOutlineEditingNote.vue": [
		87552,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		9395,
		491
	],
	"./components/noteboard/NoteBoardOutlineExport.vue": [
		1817,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		6505,
		6656,
		9688,
		4213,
		3785
	],
	"./components/noteboard/NoteBoardOutlineExportDocx.vue": [
		65134,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		5780,
		6656,
		2360
	],
	"./components/noteboard/NoteBoardOutlineExportGoogleDocs.vue": [
		76594,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		6505,
		4213,
		9700
	],
	"./components/noteboard/NoteBoardResearchNotebookLoader.vue": [
		24363,
		2567,
		4363
	],
	"./components/noteboard/NoteBoardSearch.vue": [
		65030,
		4636,
		2812,
		5030
	],
	"./components/noteboard/NoteBoardSessionLoader.vue": [
		7034,
		7034
	],
	"./components/noteboard/NoteBoardTagFilter.vue": [
		93735,
		2639,
		2812,
		3735
	],
	"./components/noteboard/NoteBoardTrashButton.vue": [
		77585,
		7585
	],
	"./components/noteboard/NoteBoardTrashPanel.vue": [
		96717,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		5658,
		9395,
		665
	],
	"./components/noteboard/NoteBoardUserList.vue": [
		28944,
		2639,
		2872,
		2772,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		4168,
		5945
	],
	"./components/noteboard/NoteBoardUserTag.vue": [
		4168,
		2639,
		2872,
		2772,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		4168,
		4002
	],
	"./components/noteboard/NoteBoardWrapper.vue": [
		65171,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		8661,
		6505,
		6656,
		2567,
		8804,
		960,
		5658,
		1300,
		4750,
		9395,
		9688,
		4213,
		4168,
		6438
	],
	"./components/noteboard/NoteBoardsList.vue": [
		65205,
		2639,
		4636,
		2872,
		2772,
		7980,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		5887,
		7130,
		4948
	],
	"./components/noteboard/OutlineExportForm.vue": [
		52737,
		2639,
		4636,
		2772,
		5019,
		4689
	],
	"./components/noteboard/RemoveNoteBoardUserDialog.vue": [
		3521,
		2872,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6656,
		3112
	],
	"./components/noteboard/SelectedNoteBoardNoteTrashControls.vue": [
		45331,
		2872,
		7838
	],
	"./components/noteboard/SiteFaviconWithTooltip.vue": [
		72694,
		2639,
		2694
	],
	"./components/noteboard/TipTapNoteBoardNote.vue": [
		65052,
		5052
	],
	"./components/noteboard/TipTapNoteBoardNoteContents.vue": [
		70731,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		3031,
		432,
		5090,
		3353,
		2567,
		960,
		9395,
		7935
	],
	"./components/noteboard/TipTapNoteBoardNotePlaceholder.vue": [
		74163,
		6544
	],
	"./components/noteboard/TransferNoteBoardOwnershipDialog.vue": [
		28906,
		2872,
		1467
	],
	"./components/roleIcons/AdministratorIcon.vue": [
		34736,
		4736
	],
	"./components/roleIcons/InstructorIcon.vue": [
		79108,
		9108
	],
	"./components/roleIcons/LearnerIcon.vue": [
		88439,
		8439
	],
	"./components/rosterTable/AddUsersButton.vue": [
		97744,
		4636,
		2872,
		7256
	],
	"./components/rosterTable/PageControls.vue": [
		35994,
		5994
	],
	"./components/rosterTable/ResourceRoster.vue": [
		65964,
		2639,
		4636,
		2872,
		2812,
		5964,
		2154
	],
	"./components/rosterTable/UserRolesTableCell.vue": [
		98677,
		8677
	],
	"./components/rosterTable/UserRolesTableHeaderColumn.vue": [
		75605,
		5605
	],
	"./courses/CourseAssignmentsRoot.vue": [
		97869,
		7869
	],
	"./courses/CourseAssignmentsView.vue": [
		47325,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		6392
	],
	"./courses/CoursePortal.vue": [
		30254,
		254
	],
	"./courses/CourseRoot.vue": [
		25574,
		9916,
		9326
	],
	"./courses/CourseRosterView.vue": [
		20491,
		2639,
		4636,
		2872,
		2812,
		5964,
		4411
	],
	"./courses/CourseSectionsRoot.vue": [
		16266,
		6266
	],
	"./courses/CourseSectionsView.vue": [
		45751,
		2639,
		4636,
		2872,
		5875,
		2342,
		7671,
		4794,
		9636
	],
	"./courses/CourseSettingsView.vue": [
		96883,
		2639,
		4636,
		2872,
		2772,
		5019,
		2342,
		8589
	],
	"./courses/components/AddSection.vue": [
		92722,
		4636,
		2872,
		5875,
		2342,
		6058
	],
	"./courses/components/ArchiveCourseDialog.vue": [
		3449,
		3449
	],
	"./courses/components/AssignmentListItem.vue": [
		4201,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		8100
	],
	"./courses/components/CourseAddAssignment.vue": [
		73023,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		8026
	],
	"./courses/components/CourseAssignmentList.vue": [
		98980,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		2475
	],
	"./courses/components/SectionForm.vue": [
		14713,
		4636,
		5875,
		2342,
		4713
	],
	"./courses/components/SectionList.vue": [
		24794,
		2639,
		4636,
		2872,
		5875,
		2342,
		7671,
		4794,
		5534
	],
	"./courses/components/SectionListItem.vue": [
		57671,
		2639,
		7671,
		2981
	],
	"./noteBoard/NoteBoardPortal.vue": [
		94043,
		8661,
		4043
	],
	"./noteBoard/NoteBoardRoot.vue": [
		37652,
		8661,
		7652
	],
	"./noteBoard/NoteBoardView.vue": [
		1025,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		8661,
		6505,
		6656,
		2567,
		8804,
		960,
		5658,
		1300,
		4750,
		9395,
		9688,
		4213,
		4168,
		5175
	],
	"./noteBoards/NoteBoardRouteContainer.vue": [
		93078,
		8661,
		3078,
		7031
	],
	"./noteBoards/NoteBoardsPortal.vue": [
		42460,
		8661,
		3078,
		2715
	],
	"./noteBoards/NoteBoardsRoot.vue": [
		45010,
		8661,
		3078,
		5829
	],
	"./noteBoards/NoteBoardsSessionCreateView.vue": [
		63691,
		4636,
		2872,
		2772,
		5875,
		5742,
		4694
	],
	"./noteBoards/NoteBoardsSessionPortal.vue": [
		67566,
		8661,
		7566
	],
	"./noteBoards/NoteBoardsSessionRoot.vue": [
		82740,
		8661,
		3078,
		5301
	],
	"./noteBoards/NoteBoardsSessionSelectView.vue": [
		95933,
		2639,
		4636,
		2872,
		2772,
		7980,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		5658,
		1300,
		4750,
		5887,
		7130,
		1808
	],
	"./noteBoards/NoteBoardsSessionsRoot.vue": [
		88246,
		8246
	],
	"./noteBoards/NoteBoardsView.vue": [
		87594,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		8661,
		6656,
		1300,
		4750,
		5887,
		7130,
		3078,
		5742,
		3608
	],
	"./organizations/CoursesRoot.vue": [
		11146,
		1146
	],
	"./organizations/CoursesView.vue": [
		52060,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		2342,
		8661,
		9916,
		4946,
		1716,
		6692,
		3511,
		7871
	],
	"./organizations/OrganizationRoot.vue": [
		44719,
		9916,
		4601
	],
	"./organizations/OrganizationRosterView.vue": [
		62807,
		2639,
		4636,
		2872,
		2812,
		5964,
		6935
	],
	"./organizations/OrganizationSettingsView.vue": [
		79773,
		4636,
		2342,
		9773
	],
	"./organizations/OrganizationsRoot.vue": [
		10767,
		767
	],
	"./organizations/OrganizationsView.vue": [
		19233,
		2639,
		9916,
		447,
		1123
	],
	"./organizations/components/AddCourse.vue": [
		67570,
		4636,
		2872,
		5875,
		2342,
		5562
	],
	"./organizations/components/AddCourseButton.vue": [
		82323,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		2342,
		8661,
		9916,
		4946,
		1716,
		2323
	],
	"./organizations/components/ArchiveOrganizationDialog.vue": [
		48849,
		8849
	],
	"./organizations/components/CourseList.vue": [
		13511,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		2342,
		8661,
		9916,
		4946,
		1716,
		6692,
		3511,
		1920
	],
	"./organizations/components/CourseListItem.vue": [
		16692,
		2639,
		6692,
		7255
	],
	"./organizations/components/GoogleClassroomCourses.vue": [
		34070,
		2639,
		2872,
		2772,
		5875,
		6934
	],
	"./organizations/components/OrganizationForm.vue": [
		69280,
		4636,
		5875,
		2342,
		9280
	],
	"./organizations/components/OrganizationList.vue": [
		41622,
		2639,
		447,
		9250
	],
	"./organizations/components/OrganizationListItem.vue": [
		10447,
		2639,
		447,
		9333
	],
	"./organizations/components/RemoveUsersFromOrgConfirmDialog.vue": [
		53094,
		2872,
		3463
	],
	"./organizations/components/RemoveUsersFromResourceConfirmDialog.vue": [
		96389,
		2872,
		4335
	],
	"./organizations/components/UpgradeCourseForm.vue": [
		52677,
		4636,
		2342,
		2677
	],
	"./organizations/components/courseForm/CourseForm.vue": [
		99517,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		2342,
		8661,
		9916,
		4946,
		1716
	],
	"./organizations/components/courseForm/ImportFromClassroomForm.vue": [
		14946,
		5875,
		8661,
		4946,
		4474
	],
	"./organizations/components/courseForm/SectionItem.vue": [
		48780,
		4636,
		2342,
		8780
	],
	"./organizations/components/courseForm/SectionSymbol.vue": [
		44292,
		4292
	],
	"./popups/CustomTokenAuthView.vue": [
		20645,
		645
	],
	"./popups/CustomTokenSignInView.vue": [
		42128,
		2128
	],
	"./popups/ExtensionErrorView.vue": [
		42036,
		2036
	],
	"./popups/ExtensionErrorView2.vue": [
		74139,
		4139
	],
	"./popups/GetCustomTokenView.vue": [
		14021,
		4021
	],
	"./popups/LoadCustomTokenView.vue": [
		43411,
		3411
	],
	"./popups/LocalHostSignInView.vue": [
		48865,
		1246
	],
	"./popups/PopupsRoot.vue": [
		26647,
		6647
	],
	"./popups/StoppedLoggingAssignmentView.vue": [
		68436,
		8436
	],
	"./popups/StoppedLoggingMessageView.vue": [
		54658,
		4658
	],
	"./popups/assignment/AssignmentPopupRoot.vue": [
		31661,
		1661
	],
	"./popups/assignment/InstructorStopLoggingView.vue": [
		90682,
		682
	],
	"./popups/session/ExportBibliographyView.vue": [
		7774,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6505,
		7774
	],
	"./popups/session/ExportNotesView.vue": [
		69961,
		7980,
		2209,
		813,
		3031,
		1452,
		9439,
		5780,
		6505,
		9961
	],
	"./popups/session/SessionPopupRoot.vue": [
		8838,
		8838
	],
	"./popups/session/SleepStopLoggingView.vue": [
		83989,
		3989
	],
	"./popups/session/components/DocsExporter.vue": [
		40592,
		592
	],
	"./sections/SectionAssignmentsRoot.vue": [
		21494,
		1494
	],
	"./sections/SectionAssignmentsView.vue": [
		68877,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		6344
	],
	"./sections/SectionRoot.vue": [
		87093,
		9916,
		5412
	],
	"./sections/SectionRosterView.vue": [
		45514,
		2639,
		4636,
		2872,
		2812,
		5964,
		8328
	],
	"./sections/SectionSettingsView.vue": [
		50254,
		2639,
		4636,
		2872,
		2772,
		5019,
		2342,
		2376
	],
	"./sections/components/ArchiveSectionDialog.vue": [
		35692,
		5692
	],
	"./sections/components/SectionAddAssignment.vue": [
		59783,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		5234
	],
	"./sections/components/SectionAssignmentList.vue": [
		78407,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		2342,
		3353,
		6505,
		8804,
		3191,
		8389,
		6879,
		3476,
		4302,
		1590,
		782,
		638,
		1723,
		3858
	],
	"./sessions/SessionBibliographyView.vue": [
		44806,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		6505,
		2567,
		960,
		9688,
		746,
		953,
		3611,
		38,
		7934,
		1308
	],
	"./sessions/SessionData.vue": [
		92945,
		2639,
		4636,
		2772,
		7980,
		5875,
		2812,
		5019,
		3572,
		1279,
		6993,
		4988,
		3084,
		650,
		6763,
		9469,
		8488
	],
	"./sessions/SessionDataView.vue": [
		52910,
		2639,
		4636,
		2872,
		2772,
		7980,
		5875,
		2812,
		2209,
		813,
		5019,
		3031,
		1452,
		9439,
		5780,
		432,
		5090,
		3353,
		6505,
		2567,
		960,
		9688,
		3572,
		1279,
		746,
		6993,
		4988,
		953,
		3611,
		3084,
		7934,
		8004
	],
	"./sessions/SessionList.vue": [
		13181,
		2639,
		3181
	],
	"./sessions/SessionListItem.vue": [
		44773,
		2639,
		4773
	],
	"./sessions/SessionPortal.vue": [
		69663,
		9663
	],
	"./sessions/SessionRoot.vue": [
		46369,
		2772,
		8767
	],
	"./sessions/SessionView.vue": [
		23361,
		3361
	],
	"./sessions/SessionsRoot.vue": [
		8897,
		8897
	],
	"./sessions/SessionsView.vue": [
		95693,
		2639,
		9916,
		447,
		8175
	],
	"./studentReport/StudentReportRoot.vue": [
		46640,
		6640
	],
	"./studentReport/StudentReportView.vue": [
		95877,
		7980,
		2812,
		6249,
		354
	],
	"./studentReport/components/CustomPieChart.vue": [
		79334,
		2812,
		6953
	],
	"./studentReport/components/CustomPieChartWithKey.vue": [
		76249,
		2812,
		6249,
		7710
	],
	"./studentReport/components/LearnicsSnapshotTitle.vue": [
		96466,
		6466
	],
	"./studentReport/components/PercentageChartKey.vue": [
		4631,
		4631
	],
	"./studentReport/components/ReportDetailList.vue": [
		96964,
		6964
	],
	"./studentReport/components/ReportGenerationError.vue": [
		6542,
		6542
	],
	"./studentReport/components/ReportPieChart.vue": [
		92095,
		2095
	],
	"./studentReport/components/ReportSitesTable.vue": [
		8242,
		8242
	],
	"./u/LearnicsUPaymentPortalView.vue": [
		7487,
		7487
	],
	"./u/LearnicsURoot.vue": [
		37373,
		7373
	],
	"./u/LearnicsUTermsOfServiceView.vue": [
		65724,
		5724
	],
	"./u/LearnicsUTourView.vue": [
		71107,
		1107
	],
	"./u/components/LearnicsUTermsOfService.vue": [
		45004,
		5004
	],
	"./u/components/LearnicsUTourStep1.vue": [
		83983,
		3983
	],
	"./u/components/LearnicsUTourStep2.vue": [
		96978,
		6978
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94235;
module.exports = webpackAsyncContext;